<template>
  <div>
    <!-- FILTROS (4.6) -->
    <form class="row" @submit.prevent="buscar(1)">
      <div class="col-md-2 mb-2">
        <label>De</label>
        <input type="date" class="form-control" v-model="filtros.de" :disabled="!!filtros.lote" />
      </div>
      <div class="col-md-2 mb-2">
        <label>Até</label>
        <input type="date" class="form-control" v-model="filtros.ate" :disabled="!!filtros.lote" />
      </div>
      <div class="col-md-3 mb-2">
        <label>Usuário alterado</label>
        <input type="text" class="form-control" placeholder="Login" v-model="filtros.usuario" />
      </div>
      <div class="col-md-3 mb-2">
        <label>Responsável</label>
        <input type="text" class="form-control" placeholder="Login" v-model="filtros.responsavel" />
      </div>
      <div class="col-md-2 mb-2 d-flex align-items-end">
        <button type="submit" class="btn btn-primary btn-block" :disabled="carregando"><i class="fas fa-search"></i> Filtrar</button>
      </div>
      <div class="col-12 mb-2" v-if="filtros.lote">
        <span class="badge badge-info p-2">
          Lote {{ filtros.lote }}
          <a href="javascript:void(0)" class="text-white ml-2" @click="limparLote" title="Remover filtro de lote">&times;</a>
        </span>
      </div>
    </form>

    <div class="table-responsive">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th>Data/hora</th>
            <th>Usuário alterado</th>
            <th>Responsável</th>
            <th>Operação</th>
            <th>De-para</th>
            <th>Lote</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="linha in linhas" :key="linha.id">
            <td style="white-space: nowrap;">{{ formatarData(linha.data_hora) }}</td>
            <td>{{ linha.usuario_alterado_login }}</td>
            <td>{{ linha.responsavel_login }}</td>
            <td>{{ nomesOperacao[linha.operacao] || linha.operacao }}</td>
            <td>
              <div>
                <small class="text-muted">Antes:</small>
                <span v-for="(fila, i) in linha.filas_antes" :key="'a' + i" class="badge mr-1" :class="(linha.filas_removidas || []).includes(fila) ? 'badge-danger' : 'badge-light'">{{ fila }}</span>
                <span v-if="!linha.filas_antes || linha.filas_antes.length == 0" class="text-muted"><small>nenhuma fila</small></span>
              </div>
              <div>
                <small class="text-muted">Depois:</small>
                <span v-for="(fila, i) in linha.filas_depois" :key="'d' + i" class="badge mr-1" :class="(linha.filas_adicionadas || []).includes(fila) ? 'badge-success' : 'badge-light'">{{ fila }}</span>
                <span v-if="!linha.filas_depois || linha.filas_depois.length == 0" class="text-muted"><small>nenhuma fila</small></span>
              </div>
            </td>
            <td>
              <a href="javascript:void(0)" @click="abrirLote(linha.lote_id)" :title="linha.lote_id">{{ linha.lote_id.substr(0, 8) }}</a>
            </td>
          </tr>
          <tr v-if="!carregando && linhas.length == 0">
            <td colspan="6" class="text-center text-muted">Nenhuma alteração encontrada no período.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-between align-items-center" v-if="paginacao.last_page > 1">
      <button class="btn btn-outline-secondary btn-sm" :disabled="paginacao.current_page <= 1 || carregando" @click="buscar(paginacao.current_page - 1)">Anterior</button>
      <small class="text-muted">Página {{ paginacao.current_page }} de {{ paginacao.last_page }} · {{ paginacao.total }} registros</small>
      <button class="btn btn-outline-secondary btn-sm" :disabled="paginacao.current_page >= paginacao.last_page || carregando" @click="buscar(paginacao.current_page + 1)">Próxima</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    loteInicial: { type: String, default: '' },
  },
  data() {
    return {
      filtros: {
        de: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        ate: moment().format('YYYY-MM-DD'),
        usuario: '',
        responsavel: '',
        lote: this.loteInicial || '',
      },
      linhas: [],
      paginacao: { current_page: 1, last_page: 1, total: 0 },
      carregando: false,
      nomesOperacao: {
        adicionar: 'Adicionar',
        remover: 'Remover',
        mover: 'Mover',
        substituir: 'Substituir',
        edicao_individual: 'Edição individual',
        retornar: 'Retorno (término do agendamento)',
      },
    };
  },
  mounted() {
    this.buscar(1);
  },
  methods: {
    buscar(pagina) {
      this.carregando = true;
      axios.get('/user_queues/log', { params: Object.assign({ page: pagina }, this.filtros) })
        .then(response => {
          this.linhas = response.data.data || [];
          this.paginacao = response.data;
        })
        .catch(error => {
          console.error(error);
          Swal.fire({ title: 'Histórico de filas', type: 'error', text: 'Erro ao carregar o histórico.' });
        })
        .finally(() => { this.carregando = false; });
    },
    // UM CLIQUE NO LOTE ABRE TODAS AS LINHAS DELE
    abrirLote(lote) {
      this.filtros.lote = lote;
      this.filtros.usuario = '';
      this.filtros.responsavel = '';
      this.buscar(1);
    },
    limparLote() {
      this.filtros.lote = '';
      this.buscar(1);
    },
    formatarData(data) {
      return moment(data, 'YYYY-MM-DD HH:mm:ss.SSS').format('DD/MM/YYYY HH:mm:ss');
    },
  },
};
</script>
